<div class="vertical-menu" (mouseenter)="onSidebarHover(true)" (mouseleave)="onSidebarMouseLeave($event)">
  <ngx-simplebar class="h-100" #ngxSimplebar>
    <div class="my-4 mx-3 d-flex flex-column flex-grow-1">
      <div class="menu menu-column menu-rounded menu-sub-indention fw-semibold fs-6 flex-grow-1">

        <ng-container *ngFor="let item of menuItems; trackBy: trackMenuItem">
          <div class="menu-item" [class.d-none]="item.hidden">

            <!-- LOCKED (any item) -->
            <ng-container *ngIf="item.locked">
              <ng-container *ngTemplateOutlet="lockedItemTpl; context: { item: item }"></ng-container>
            </ng-container>

            <!-- PARENT WITH SUB-ITEMS (not locked) -->
            <ng-container *ngIf="item.subItems?.length && !item.locked">
              <div class="bg-transparent border-0" ngbAccordion [animation]="true">
                <div ngbAccordionItem [collapsed]="!isParentActive(item)" class="bg-transparent border-0">
                  <div class="bg-transparent border-0" ngbAccordionHeader>
                    <button class="menu-link bg-transparent border-0 outline-0 shadow-none" ngbAccordionButton (mouseenter)="onMenuItemHover()">
                      <span *ngIf="item.icon" class="menu-icon"><i class="{{ item.icon }}"></i></span>
                      <span class="menu-title text-nowrap">{{ item.untranslatedLabel ? item.label : (labelTranslationKey + item.label | transloco) }}</span>
                    </button>
                  </div>
                  <div class="border-0" ngbAccordionCollapse>
                    <div class="border-0 pb-0 pt-2 accordion-body-custom" ngbAccordionBody>

                      <ng-container *ngFor="let subitem of item.subItems; trackBy: trackMenuItem">
                        <div [class.d-none]="subitem?.hidden">

                          <!-- Sub-item: LOCKED -->
                          <ng-container *ngIf="subitem?.locked">
                            <ng-container *ngTemplateOutlet="lockedItemTpl; context: { item: subitem }"></ng-container>
                          </ng-container>

                          <!-- Sub-item: HAS 3RD LEVEL (not locked) -->
                          <ng-container *ngIf="subitem?.subItems?.length && !subitem?.locked && !subitem?.routePath">
                            <div class="bg-transparent border-0" ngbAccordion [animation]="true">
                              <div ngbAccordionItem [collapsed]="!isParentActive(subitem)" class="bg-transparent border-0">
                                <div class="bg-transparent border-0" ngbAccordionHeader>
                                  <button class="menu-link sub-link bg-transparent border-0 outline-0 shadow-none" ngbAccordionButton>
                                    <span class="menu-title text-nowrap">{{ subitem.untranslatedLabel ? subitem.label : (labelTranslationKey + subitem.label | transloco) }}</span>
                                  </button>
                                </div>
                                <div class="border-0" ngbAccordionCollapse>
                                  <div class="border-0 pb-0 pt-1 accordion-body-custom" ngbAccordionBody>
                                    <ng-container *ngFor="let subSubitem of subitem.subItems; trackBy: trackMenuItem">
                                      <div [class.d-none]="subSubitem?.hidden">
                                        <!-- Sub-sub-item: LOCKED -->
                                        <ng-container *ngIf="subSubitem?.locked">
                                          <ng-container *ngTemplateOutlet="lockedItemTpl; context: { item: subSubitem }"></ng-container>
                                        </ng-container>
                                        <!-- Sub-sub-item: LEAF (not locked) -->
                                        <ng-container *ngIf="!subSubitem?.locked">
                                          <ng-container *ngTemplateOutlet="leafItemTpl; context: { item: subSubitem, sectionIcon: item.icon }"></ng-container>
                                        </ng-container>
                                      </div>
                                    </ng-container>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-container>

                          <!-- Sub-item: LEAF (no children, not locked) -->
                          <ng-container *ngIf="(!subitem?.subItems?.length || subitem?.routePath) && !subitem?.locked">
                            <ng-container *ngTemplateOutlet="leafItemTpl; context: { item: subitem, sectionIcon: item.icon }"></ng-container>

                            <div *ngIf="subitem?.subItems?.length" class="menu-nested-items">
                              <ng-container *ngFor="let nestedItem of subitem.subItems; trackBy: trackMenuItem">
                                <div [class.d-none]="nestedItem?.hidden">
                                  <ng-container *ngTemplateOutlet="leafItemTpl; context: { item: nestedItem, sectionIcon: item.icon }"></ng-container>
                                </div>
                              </ng-container>
                            </div>
                          </ng-container>

                        </div>
                      </ng-container>

                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- LEAF: no subItems, not locked -->
            <ng-container *ngIf="!item.subItems?.length && !item.locked">
              <ng-container *ngTemplateOutlet="leafItemTpl; context: { item: item }"></ng-container>
            </ng-container>

          </div>
        </ng-container>

      </div>
    </div>
  </ngx-simplebar>
</div>


<!-- ===== LEAF ITEM (route or action) ===== -->
<ng-template #leafItemTpl let-item="item" let-sectionIcon="sectionIcon">
  <!-- Action -->
  <ng-container *ngIf="item?.action">
    <app-upgradeable-item
      #sideNavLink
      [classList]="'menu-link without-sub cursor-pointer'"
      [isLocked]="false"
      [permission]="item.identifier"
      (itemClick)="onClick(item.action, item.options, item.icon || sectionIcon)"
      (upgradeClick)="onUpgradeClick($event)"
    >
      <span *ngIf="item.icon" class="menu-icon"><i class="{{ item.icon }}"></i></span>
      <span *ngIf="item.iconUrl" class="menu-icon menu-icon--image"><img [src]="item.iconUrl" alt="" /></span>
      <span class="menu-title text-nowrap">{{ item.untranslatedLabel ? item.label : (labelTranslationKey + item.label | transloco) }}</span>
      <i *ngIf="item.external" class="mdi mdi-open-in-new menu-external-icon"></i>
      <span *ngIf="item.connected" class="menu-connected-dot"></span>
    </app-upgradeable-item>
  </ng-container>

  <!-- Route -->
  <ng-container *ngIf="item?.routePath && !item?.action">
    <app-upgradeable-item
      #sideNavLink
      [classList]="'menu-link without-sub cursor-pointer'"
      [isLocked]="false"
      [routerLink]="item.routePath"
      [routerLinkActiveOptions]="{ exact: !item.options?.pathWithParam }"
      [permission]="item.identifier"
      (itemClick)="onRouterLink()"
      (upgradeClick)="onUpgradeClick($event)"
    >
      <span *ngIf="item.icon" class="menu-icon"><i class="{{ item.icon }}"></i></span>
      <span *ngIf="item.iconUrl" class="menu-icon menu-icon--image"><img [src]="item.iconUrl" alt="" /></span>
      <span class="menu-title text-nowrap">{{ item.untranslatedLabel ? item.label : (labelTranslationKey + item.label | transloco) }}</span>
      <i *ngIf="item.external" class="mdi mdi-open-in-new menu-external-icon"></i>
      <span *ngIf="item.connected" class="menu-connected-dot"></span>
    </app-upgradeable-item>
  </ng-container>
</ng-template>

<!-- ===== LOCKED ITEM ===== -->
<ng-template #lockedItemTpl let-item="item">
  <app-upgradeable-item
    [classList]="'menu-link without-sub cursor-not-allowed'"
    [isLocked]="true"
    [canUpgrade]="item?.canUpgrade !== false"
    [permission]="item?.identifier"
    (upgradeClick)="onUpgradeClick($event)"
  >
    <span *ngIf="item?.icon" class="menu-icon"><i class="{{ item.icon }}"></i></span>
    <span class="menu-title text-nowrap">{{ item?.untranslatedLabel ? item?.label : (labelTranslationKey + item?.label | transloco) }}</span>
    <i class="mdi mdi-lock ms-auto"></i>
  </app-upgradeable-item>
</ng-template>
